import * as actions from "./note.actions";
import * as api from "./note.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./note.constants";
import * as hooks from "./note.hooks";
import * as promises from "./note.promises";
import reducer from "./note.reducer";
import { saga } from "./note.saga";
import * as selectors from "./note.selectors";
import * as utils from "./note.utils";
export * from "./note.types";
export var REDUCER_KEY_NOTE = REDUCER_KEY;
export var noteModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
